// extracted by mini-css-extract-plugin
export var item = "NumberCountersListItem-module--item--56104";
export var label = "NumberCountersListItem-module--label--12ea0";
export var number = "NumberCountersListItem-module--number--1da57";
export var suffix = "NumberCountersListItem-module--suffix--c0d35";